import React from 'react'
import { Tag } from '@chakra-ui/react'
import { AddIcon } from '@chakra-ui/icons'

function AddTagButton(props) {
    return (
        <Tag
            m="2px"
            cursor='pointer'
            _hover={{
                background: "lightgray"
            }}
            {...props}
        >
            <AddIcon />
        </Tag>
    )
}

export default AddTagButton
